import "./styles.scss";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { useDashboard } from "context/admin/dashboard";
import { useTimeTracking } from "context/time-tracking";

import DataTile from "components/DataTile";
import Loader from "components/Loader";
import TaskInfo from "components/TaskInfo";

import task_status_data from "libs/task_status_data.json";
import task_priority_data from "libs/task_priority_data.json";

import { ReactComponent as NoDataIcon } from "assets/icons/no-data.svg";

const mainClass = "dashboard-admin-deadline-tasks-tiles";

const DeadlineTasksTiles = ({ setWebsiteInfoId, setExplanation }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data, loading, updateTask, refetchTasks } = useDashboard();
  const { current, timeTracking } = useTimeTracking();

  return (
    <div className={mainClass}>
      <div className={`${mainClass}__row`}>
        {!loading ? (
          data?.tasks_upcoming_date?.length > 0 ? (
            data.tasks_upcoming_date.map(
              ({
                _id,
                created_at,
                title,
                website,
                website_id,
                status,
                priority,
                due_date,
                total_time,
              }) => {
                const status_data = task_status_data?.find(
                  (item) => item?.value === (status ?? 1),
                );
                const priority_data = task_priority_data?.find(
                  (item) => item?.value === (priority ?? 1),
                );

                return (
                  <DataTile
                    key={_id}
                    label={title}
                    status={{
                      data: {
                        value: status_data?.value,
                        label: t(status_data?.label),
                        color: status_data?.color,
                      },
                      options: task_status_data
                        .filter((item) => item?.key !== "canceled")
                        .map((item) => ({ ...item, label: t(item.label) })),
                      optionsFooter: (
                        <TaskInfo onClick={() => setExplanation("status")} />
                      ),
                      isCompact: true,
                      onChange: (option) =>
                        updateTask(_id, { status: option.value }, [
                          "admin_dashboard",
                        ]),
                    }}
                    priority={{
                      data: {
                        value: priority_data?.value,
                        label: t(priority_data?.label),
                        color: priority_data?.color,
                      },
                      icon: "flag",
                      options: task_priority_data.map((item) => ({
                        ...item,
                        label: t(item.label),
                      })),
                      optionsFooter: (
                        <TaskInfo
                          type="priority"
                          onClick={() => setExplanation("priority")}
                        />
                      ),
                      isCompact: true,
                      onChange: (option) =>
                        updateTask(_id, { priority: option.value }),
                    }}
                    time_tracker={{
                      label: total_time,
                      start_time_tracked:
                        current?.tasks?.[0]?._id === _id
                          ? current?.start
                          : null,
                      onclick: () => timeTracking(_id, refetchTasks),
                    }}
                    due_date={{
                      value: due_date,
                      onChange: async (date) => {
                        await updateTask(_id, { due_date: date });
                        refetchTasks();
                      },
                    }}
                    created_at={created_at}
                    website={{
                      name: website,
                      onClick: () => setWebsiteInfoId(website_id),
                    }}
                    onClick={() => navigate(`/tasks/${_id}`)}
                  />
                );
              },
            )
          ) : (
            <div className={`${mainClass}__no-data`}>
              <NoDataIcon />
              <p>{t("No data")}</p>
            </div>
          )
        ) : (
          <div className={`${mainClass}__loader`}>
            <Loader color="blue" center size="large" />
          </div>
        )}
      </div>
    </div>
  );
};

export default DeadlineTasksTiles;
